import { cx } from '@linaria/core';
import { closeButtonCls } from './util.close-button.style.js';
import { jsx } from 'react/jsx-runtime';

function CloseButton(props) {
  return /*#__PURE__*/jsx("button", {
    className: cx(closeButtonCls, props.className),
    type: "button",
    "aria-label": props.label,
    onClick: props.onClose,
    children: /*#__PURE__*/jsx("span", {})
  });
}

export { CloseButton };
//# sourceMappingURL=util.close-button.js.map
